export default {
  navigation: {
    next: "Seguinte",
    back: "Anterior",
    surveyNavigation: "Navegação do questionário",
    workspace: {
      home: "Início",
      example: "Exemplo"
    }
  }
}
